import { InvoiceDocumentTypeEnum } from "@altertec_gparn/lib";

interface InvoiceDocumentTypeAmountPayload {
  type?: InvoiceDocumentTypeEnum;
  amount?: number | null;
  totalAmount?: number | null;
  allocatedAmount?: number | null;
}

export function isCreditNoteAmount(value: number | null | undefined): boolean {
  return value != null && value < 0;
}

export function resolveInvoiceDocumentType(
  payload: InvoiceDocumentTypeAmountPayload
): InvoiceDocumentTypeEnum | undefined {
  if (payload.type) {
    return payload.type;
  }

  const referenceAmount = payload.totalAmount ?? payload.allocatedAmount ?? payload.amount;

  if (isCreditNoteAmount(referenceAmount)) {
    return InvoiceDocumentTypeEnum.CREDIT_NOTE;
  }

  return undefined;
}
